import {mapLegacyPagination} from '@/store/utils'
import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'
// Modules
import metricType from './metric-type'

const initialState = () => ({
    metricTypes: {
        data: [],
        pagination: {}
    },
    metricTypesSearch: {
        data: []
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        metricTypes: state => state.metricTypes,
        metricTypesSearch: state => state.metricTypesSearch
    },
    actions: {
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        listMetricTypes: async ({commit, dispatch}, query) => {
            try {
                const response = await api.metricTypes.searchMetricTypes(query)
                commit(mutationTypes.SET_METRIC_TYPES, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        searchMetricTypes: async ({commit, dispatch}, query) => {
            try {
                const response = await api.metricTypes.searchMetricTypes(query)
                commit(mutationTypes.SET_METRIC_TYPES_SEARCH, response)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetMetricTypes: async ({commit}) => commit(mutationTypes.RESET_METRIC_TYPES),
        resetMetricTypesSearch: async ({commit}) => commit(mutationTypes.RESET_METRIC_TYPES_SEARCH)
    },
    modules: {
        metricType
    },
    mutations: {
        [mutationTypes.RESET_METRIC_TYPES]: state => Object.assign(state, initialState()),
        [mutationTypes.RESET_METRIC_TYPES_SEARCH]: state => {
            state.metricTypesSearch = initialState().metricTypesSearch
        },
        [mutationTypes.SET_METRIC_TYPES]: (state, data) => {
            state.metricTypes = {
                ...data,
                pagination: mapLegacyPagination(data.pagination)
            }
        },
        [mutationTypes.SET_METRIC_TYPES_SEARCH]: (state, data) => {
            state.metricTypesSearch = data
        }
    }
}
